import React, { useCallback } from 'react'
import { useAdminI18n } from 'i18n/feature'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { TableInstance } from 'react-table'
import TableMenuButton from 'civic-champs-shared/core/TableMenuButton'
import ListIcon from '@material-ui/icons/List'
import { ColumnSelectorModal } from 'core/table/components/ColumnSelectorModal'
import useSetColumnState from 'core/table/table-hooks/useSetColumnState'

export const ColumnSelector = ({ table, tableName }: { table: TableInstance; tableName?: string }) => {
  const { t } = useAdminI18n('admin')
  const showModal = useShowPrompt(ColumnSelectorModal)
  const [setColumnState] = useSetColumnState()
  const handleClick = useCallback(async () => {
    const columns: any[] = await showModal({ table })
    if (columns) {
      const lockedColumnIds = table.allColumns
        .slice(1)
        .filter((column: any) => column.hideInSelector)
        .map((column: any) => column.id)
      const customizableIds = columns.map(({ id }) => id)
      const hiddenColumns = columns.filter(({ checked }) => !checked).map(({ id }) => id)
      const columnOrder = [...customizableIds, ...lockedColumnIds]

      table.setHiddenColumns(hiddenColumns)
      // @ts-ignore
      table.setColumnOrder(columnOrder)
      tableName &&
        (await setColumnState(
          tableName,
          columnOrder.map(id => ({
            id,
            visible: !hiddenColumns.includes(id),
          })),
        ))
    }
  }, [setColumnState, showModal, table, tableName])
  return (
    <TableMenuButton endIcon={<ListIcon />} onClick={handleClick}>
      {t('table.customize', { defaultValue: 'Customize' })}
    </TableMenuButton>
  )
}
